import { create } from 'zustand';

type Installment = {
  installment: number;
  taxes: string;
};

type Offer = {
  id: string;
  installments: number;
  rate: number;
  maxAmount: number;
  minAmount: number;
  maxInstallmentAmount: number;
  minInstallmentAmount: number;
  firstDueDate: string;
};
// type Offer = {
//   category: string;
//   min_amount: string;
//   max_amount: string;
//   min_installment_amount: string;
//   max_installment_amount: string;
//   installments: Installment[];
// };

type SelectedOffer = {
  offerId: string;
  selectedAmount: number;
  selectedInstallmentAmount: number;
  selectedInstallments: number;   
};

type SelectedOfferFromLeadGen = {
  id: string;
  amount: number;
  installmentAmount: number;
  rate: number;
  installments: number;
  firstDueDate: string;
};

type PreOffer = {
  id: string;
  installments: number;
  rate: number;
  maxAmount: number;
  minAmount: number;
  maxInstallmentAmount: number;
  minInstallmentAmount: number;
  firstDueDate: string;
};

type FormState = {
  token: string | null;
  hash: string | null;
  offer: Offer[] | null; 
  preOffers: PreOffer[] | null;
  requestUid: string | null;  
  selectedOfferData: SelectedOffer | null;
  selectedOffer: SelectedOfferFromLeadGen | null;
  name: string | null;
  cuil: string | null;
  employment: string | null;
  dni: string | null;
  email: string | null;
  phone: string | null;
  bank: string | null;
  first_name: string | null;
  last_name: string | null;
  gender: string | null;
  birthdate: string | null;
  offers: Offer[];
  setToken: (token: string) => void;
  setHash: (hash: string) => void;
  setOffer: (offers: Offer[]) => void; 
  setPreOffers: (preOffers: PreOffer[]) => void;
  setSelectedOffer: (offer: SelectedOfferFromLeadGen) => void;
  setNames: (name: string) => void;
  setCuilParameter: (cuil: string) => void;
  setEmploymentParameter: (employment: string) => void;
  setDniData: (dni: string) => void;
  setEmailData: (email: string) => void;
  setPhoneData: (phone: string) => void;
  setBankData: (bank: string) => void;
  setFirstNameData: (first_name: string) => void;
  setLastNameData: (last_name: string) => void;
  setGenderData: (gender: string) => void;
  setBirthdateData: (birthdate: string) => void;
  setRequestUid: (uid: string) => void;
  setSelectedOfferData: (offerData: SelectedOffer) => void; 
};

const useFormStore = create<FormState>((set) => ({
  token: null,
  hash: null,
  offer: null,
  preOffers: null, 
  requestUid: null,
  selectedOfferData: null, 
  selectedOffer: null,
  name: null,
  cuil: null,
  employment: null,
  dni: null,
  email: null,
  phone: null,
  bank: null,
  first_name: null,
  last_name: null,
  gender: null,
  birthdate: null,
  offers: [],
  setToken: (token: string) => set(() => ({ token })),
  setHash: (hash: string) => set(() => ({ hash })),
  setOffer: (offers) => set({ offers }),
  setPreOffers: (preOffers: PreOffer[]) => set(() => ({ preOffers })), 
  setSelectedOffer: (offer: SelectedOfferFromLeadGen) => set(() => ({ selectedOffer: offer })),
  setNames: (name: string) => set(() => ({ name })),
  setCuilParameter: (cuil: string) => set(() => ({ cuil })),
  setEmploymentParameter: (employment: string) => set(() => ({ employment })),
  setDniData: (dni: string) => set(() => ({ dni })),
  setEmailData: (email: string) => set(() => ({ email })),
  setPhoneData: (phone: string) => set(() => ({ phone })),
  setBankData: (bank: string) => set(() => ({ bank })),
  setFirstNameData: (first_name: string) => set(() => ({ first_name })),
  setLastNameData: (last_name: string) => set(() => ({ last_name })),
  setGenderData: (gender: string) => set(() => ({ gender })),
  setBirthdateData: (birthdate: string) => set(() => ({ birthdate })),
  setRequestUid: (uid: string) => set(() => ({ requestUid: uid })),
  setSelectedOfferData: (offerData: SelectedOffer) => set(() => ({ selectedOfferData: offerData })), 
}));

export default useFormStore;